import { SdkMessageTypes } from '../constants';
import { IBaseAuthenticationService, IProfile, ITelemetryScenario, ITelemetryService } from '../interfaces';
import { WebContentSdkService } from '../web-content-sdk';
import { BaseMessageHandler } from './base-message-handler';

/**
 * Responsible for handling authentication related message requests.
 */
export class BaseAuthenticationMessageHandler extends BaseMessageHandler {
  constructor(
    protected appSdkHost: WebContentSdkService,
    protected authenticationService?: IBaseAuthenticationService,
    protected telemetryService?: ITelemetryService
  ) {
    super(appSdkHost, telemetryService);
  }

  public initHandlers(): void {
    this.registerHandler(SdkMessageTypes.authentication.getUser, this.handleGetUser, {
      errorCallback: this.onGetUserError,
      isPrivate: true,
    });
  }

  protected validateDependencies() {
    if (!this.authenticationService) {
      throw 'No authentication service is available';
    }
  }

  /**
   * Request user profile for 1st-Party hosted experiences
   */
  protected async handleGetUser(): Promise<(boolean | IProfile)[]> {
    let user = await this.authenticationService!.getUser();
    if (user) {
      return [true, user.profile];
    }
    return Promise.reject('Failed to fetch the user profile');
  }

  private onGetUserError(error: any, scenario: ITelemetryScenario): Promise<(boolean | IProfile)[]> {
    scenario?.fail(`GetUser failed ${error}`);
    return Promise.resolve([false, error]);
  }
}
